import React from "react";
import CircularSpinner from "./CircularSpinner";

const LightLoader = ({ size = "md", className = "", color = "primary" }) => {
  return <CircularSpinner size={size} className={className} color={color} />;
};

export default LightLoader;
